import { IneraSiteState } from '@/inera-state-types'
import { ReactPageState } from '@platformui/core/infrastructure/features/optimizely/types'
import { createElement } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { AppClient } from './app-client'
import { registerSW } from 'virtual:pwa-register'
import { pageLookup } from './pages/page-lookup'

const main = async () => {
    const appNode = document.getElementById('app')

    if (!appNode) {
        console.error('Did not find app root element. Cannot render app!')
        return
    }

    const pageChunkName = appNode.dataset.pageTypeName

    if (!pageChunkName) {
        console.error('Did not find page chunk name. Cannot render app!')
        return
    }

    const Page = await pageLookup(pageChunkName)

    const pageState: ReactPageState = window.__PRELOADED_PAGESTATE__
    const siteState: IneraSiteState = window.__PRELOADED_SITESTATE__

    const app = createElement(AppClient, {
        page: Page,
        rootProps: {
            cookies: document.cookie,
            pageState,
            siteState,
            discriminator: 'Page',
        },
    })
    hydrateRoot(appNode, app)
}

registerSW()

main().catch((err) => console.log('Running the app failed', err))
